const tipoProposta = {
  ACIDENTE: 1,
  ACIDENTE_E_ROUBO: 2,
  ROUBO: 3
};

export default tipoProposta;


// WEBPACK FOOTER //
// ./src/helpers/tipo-proposta.js